export default __webpack_public_path__ + "static/media/cremation.48f9833b.svg";